import React from 'react';
import {Redirect} from 'react-router';
import {
  Container,
  Header,
  Segment,
  Icon,
  Dimmer,
  Loader,
  Item,
  Button,
  Label,
  Grid,
  Divider,
} from 'semantic-ui-react';
import DivWrapper from './DivWrapper';
import ReadMore from './ReadMore';
import Api from '../api';
import moment from 'moment';
import AgeRestriction from './AgeRestriction';

class CategoryPage extends React.Component {

    state = {
      category: null,
      storys: [],
    };

    componentWillUnmount(){
        this._isUnmounted = true;
    }

    async componentWillMount() {
        this._isMounted = true;
        const id = this.props.match.params.id;
        if(id){
          const category = await Api.Categories.getCategoryById(id).then(data => data.data).catch(err => -1);
          
          if(!this._isUnmounted){
              this.setState({category: category});
              let storys = await Api.Story.getStorysByCategory(category.id).then(data => data.data.storys).catch(err => []);
              let renderStorys = [];
              for(let i=0; i < storys.length; i++){

                if(typeof(storys[i].authorId) !== 'string'){
                    storys[i].authorName = [];
                    for(let k = 0; k < storys[i].authorId.length; k++) storys[i].authorName.push(
                        await Api.User.getName(storys[i].authorId[k]).then(data => data.data).catch(err => null)
                    );
                } else {
                    storys[i].authorName = await Api.User.getName(storys[i].authorId).then(data => data.data).catch(err => null);
                }
    
                if(typeof(storys[i].speakerId) !== 'string'){
                    storys[i].speakerName = [];
                    for(let k = 0; k < storys[i].speakerId.length; k++) storys[i].speakerName.push(
                        await Api.User.getName(storys[i].speakerId[k]).then(data => data.data).catch(err => null)
                    );
                } else {
                    storys[i].speakerName = await Api.User.getName(storys[i].speakerId).then(data => data.data).catch(err => null);
                }

                storys[i].category = category;
                storys[i].cover = await Api.Cover.getCoverFile(storys[i].cover).then(data => data.data.signed).catch(err => null);
                storys[i].ownerName = await Api.User.getName(storys[i].ownerId).then(data => data.data).catch(err => null);
                renderStorys.push(storys[i]);
                if(!this._isUnmounted){
                  this.setState({storys: renderStorys});
                }
              }
              if(!this._isUnmounted){
                this.setState({storys: storys});
              }
          }
        }
    }

    handleGoToUser(id){
      window.scrollTo(0,0);
      this.props.history.push('/user/'+id);
    }

    renderStorys(storys){
      let ary = [];
      for(let i=0; i < storys.length; i++){
        const s = storys[i];

        let authorRender = null;
        if(typeof(s.authorId) !== 'string'){
            let authors = [];
            for(let k=0; k < s.authorName.length; k++){
                authors.push(
                    <b key={k} style={{cursor: "pointer"}} onClick={this.handleGoToUser.bind(this, s.authorId[k])}>{`${s.authorName[k].firstName} ${s.authorName[k].lastName}`}</b>
                );
                if(k + 1 < s.authorName.length) authors.push(
                    <span key={k.toString() + "-&"}>&</span>
                );
            }
            authorRender = (
                <p>
                    <span>von {authors}</span><br/>
                </p>
            );
        } else {
            authorRender = (
                <p>
                    <span>von <b style={{cursor: "pointer"}} onClick={this.handleGoToUser.bind(this, s.authorId)}>{`${s.authorName.firstName} ${s.authorName.lastName}`}</b></span><br/>
                </p>
            );
        }

        let speakerRender = null;
        if(typeof(s.speakerId) !== 'string'){
            let speakers = [];
            for(let k=0; k < s.speakerName.length; k++){
                speakers.push(
                    <b key={k} style={{cursor: "pointer"}} onClick={this.handleGoToUser.bind(this, s.speakerId[k])}>{`${s.speakerName[k].firstName} ${s.speakerName[k].lastName}`}</b>
                );
                if(k + 1 < s.speakerName.length) speakers.push(
                    <span key={k.toString() + "-&"}>&</span>
                );
            }
            speakerRender = (
                <p>
                    gesprochen von {speakers}
                </p>
            );
        } else {
            speakerRender = (
                <p>
                    <span>gesprochen von <b style={{cursor: "pointer"}} onClick={this.handleGoToUser.bind(this, s.speakerId)}>{`${s.speakerName.firstName} ${s.speakerName.lastName}`}</b></span>
                </p>
            );
        }

        ary.push(
          <Item key={i}>
            <Item.Image style={{cursor: 'pointer'}} onClick={this.onClick.bind(this, s.id)} src={s.cover} />
            <Item.Content>
              <Item.Header as='a' onClick={this.onClick.bind(this, s.id)}>{s.title}</Item.Header>
              <Item.Meta>
                <p>Veröffentlicht am {moment(s.date_published).format("DD. MMMM YYYY")}</p>
                {authorRender}
                {speakerRender}
                <Label style={{cursor: 'pointer'}} onClick={this.toCategory.bind(this, s.category.id)}>{s.category.name}</Label>
                <AgeRestriction age={s.ageRestriction} />
              </Item.Meta>
              <Item.Description>
                <p style={{textAlign: 'justify'}}>{s.description}</p>
              </Item.Description>
              <Item.Extra>
                <Button
                  icon
                  color='green'
                  labelPosition='right'
                  floated='right'
                  onClick={this.onClick.bind(this, s.id)}
                  >
                  Hören
                  <Icon name='play' />
                </Button>
              </Item.Extra>
            </Item.Content>
          </Item>
        );
      }
      return ary;
    }

    toCategory(id){
      window.scrollTo(0,0);
      this.props.history.push('/category/'+id);
    }

    onClick(id){
      /*
        window.dataLayer.push({
            event: 'onWebsiteEvent',
            eventCategory: 'categorySite',
            eventAction: 'playProject',
            eventLabel: 'clickPlay',
            eventValue: id
        });
        */
        window.scrollTo(0,0);
        this.props.history.push('/play/'+id);
    }

    render(){
      if(this.state.category === -1) return (<Redirect to="/category" />);
        
        return (
            <DivWrapper>
            <Segment style={{border: 'none', minHeight: '60vh', marginTop: '2px', borderRadius: 0}}>
                    { this.state.category ? (
                              <Segment style={{ padding: '0em' }} vertical>
                                <Divider horizontal style={{marginBottom: '2em'}}>
                                  <Header as='h1'>
                                  {this.state.category.name}
                                  </Header>
                                </Divider>
                                <Grid container stackable verticalAlign='middle'>
                                  <Grid.Row>
                                    <Grid.Column textAlign='center'>
                                      <ReadMore
                                        style={{ fontSize: '1.5em', textAlign: 'justify' }}
                                        size={250}
                                        text={this.state.category.description}
                                      />
                                    </Grid.Column>
                                  </Grid.Row>
                                </Grid>
                              
                              {
                                this.state.storys.length > 0 ? (
                                  <Container style={{marginTop: '2em'}}>
                                    <Divider horizontal style={{margin: '4em 0em 2em 0em'}}>
                                      <Header as='h2'>
                                        <Icon name='book' />
                                        Geschichten
                                      </Header>
                                    </Divider>
                                    <Item.Group>
                                      {this.renderStorys(this.state.storys)}
                                    </Item.Group>
                                  </Container>
                                ) : (
                                  <Segment style={{marginTop: '2em', minHeight: '60vh'}}>
                                    <Dimmer active>
                                      <Loader>Geschichten werden geladen...</Loader>
                                    </Dimmer>
                                  </Segment>
                                )
                              }
                            </Segment>
                    ) : (
                        <Dimmer active>
                            <Loader>Kategorie wird geladen...</Loader>
                        </Dimmer>
                    )
                    }
            </Segment>
            </DivWrapper>
        );
    }
} 


export default CategoryPage;


// WEBPACK FOOTER //
// ./src/components/CategoryPage.js